import React, { createContext, useContext, useMemo, useState } from 'react';

interface AuthContextValue {
	token: string | null;
	isAuthenticated: boolean;
	isInitializing: boolean;
	setToken: (token: string | null) => void;
	setIsInitializing: (initializing: boolean) => void;
	logout: () => void;
}

const AuthContext = createContext<AuthContextValue | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [token, setToken] = useState<string | null>(null);
	const [isInitializing, setIsInitializing] = useState<boolean>(true);

	const logout = () => setToken(null);

	const value = useMemo(
		() => ({ token, isAuthenticated: !!token, isInitializing, setToken, setIsInitializing, logout }),
		[token, isInitializing]
	);

	return (
		<AuthContext.Provider value={value}>
			{children}
		</AuthContext.Provider>
	);
};

export const useAuth = (): AuthContextValue => {
	const ctx = useContext(AuthContext);
	if (!ctx) {
		throw new Error('useAuth must be used within an AuthProvider');
	}
	return ctx;
}; 